import { useEffect } from "react";

// Canonical production host for SEO tags (canonical URLs, Open Graph, sitemap).
export const SITE_URL = "https://hughlaunch.com";

const upsertMeta = (key, value, attr = "name") => {
  if (value == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Per-route SEO: sets a unique <title>, meta description, canonical URL,
 * robots directive and Open Graph / Twitter tags. Utility/app pages pass
 * noindex so search engines skip thin, non-marketing routes.
 */
export const Seo = ({ title, description, path = "/", noindex = false, image, jsonLd }) => {
  useEffect(() => {
    const url = path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;
    if (title) document.title = title;
    upsertMeta("description", description);
    upsertMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    upsertLink("canonical", url);

    upsertMeta("og:title", title, "property");
    upsertMeta("og:description", description, "property");
    upsertMeta("og:url", url, "property");
    upsertMeta("og:type", "website", "property");
    upsertMeta("og:site_name", "HughLaunch", "property");
    if (image) upsertMeta("og:image", image, "property");

    upsertMeta("twitter:card", "summary_large_image");
    upsertMeta("twitter:title", title);
    upsertMeta("twitter:description", description);
    if (image) upsertMeta("twitter:image", image);

    let script = document.getElementById("route-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "route-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, noindex, image, JSON.stringify(jsonLd)]);

  return null;
};
